import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import components from "./components";
import store from "./storeGlobal/index";
import directives from "./directives/index";
import "./assets/main.css";
import { vMaska } from "maska";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
// import Hotjar from "@hotjar/browser";
import VueGtag from "vue-gtag";
import "intersection-observer";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import BugsnagPerformance from "@bugsnag/browser-performance";
import axiosInstance from "@/helpers/axios";
import { saleName } from "@/helpers/saleUtils";

const app = createApp(App).directive("maska", vMaska);

// Available in every template as $saleName(sale)
app.config.globalProperties.$saleName = saleName;

components.forEach((component) => {
  app.component(component.name, component);
});

directives.forEach((directive) => {
  app.directive(directive.name, directive);
});

Bugsnag.start({
  apiKey: "f56df16859bd97c585f6f19f0a583c84",
  plugins: [new BugsnagPluginVue()],
});
BugsnagPerformance.start({ apiKey: "f56df16859bd97c585f6f19f0a583c84" });

const bugsnagVue = Bugsnag.getPlugin("vue");
bugsnagVue.installVueErrorHandler(app);

const siteId = 5105246;
// const hotjarVersion = 6;

// Hotjar.init(siteId, hotjarVersion);

app.use(router);

app.use(store);
app.config.devtools = true;

app.use(autoAnimatePlugin);

app.use(
  VueGtag,
  {
    config: { id: import.meta.env.VITE_GOOGLE_TAG_ID },
  },
  router
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Interceptor hit for successful response
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Bypass for specific routes
      const bypassPaths = ["/", "/login", "/contact", "/impersonate"];
      const currentPath = router.currentRoute.value.path;
      if (!bypassPaths.includes(currentPath)) {
        if (store && typeof store.dispatch === "function") {
          store.dispatch("logout");
        }
      }
    }
    // The API refuses everything except /profile and the password change itself
    // while the customer still has to update the password: open the popup.
    if (
      error.response &&
      error.response.status === 423 &&
      error.response.data?.code === "password_change_required"
    ) {
      // The API only answers 423 once the deadline has passed: always the blocking mode.
      // Many requests are refused at once: count the block once.
      if (!store.getters["forcePasswordChange/isEnforced"]) {
        app.config.globalProperties.$gtag?.event("password_change_required_423", {
          path: router.currentRoute.value.path,
        });
      }
      store.dispatch("forcePasswordChange/require", { enforced: true });
    }
    return Promise.reject(error);
  }
);

// Global handler for unhandled promise rejections (for debugging)
window.addEventListener("unhandledrejection", function (event) {
  console.error("Unhandled promise rejection:", event.reason);
});

app.mount("#app");
